<div
  class="annotation-points__top bold"
  [ngClass]="{'isDialog dialog': isDialog}"
>
  <span>
    {{ 'TRANS__ANNOTATION__ANNOTATION_POINTS' | translate }}
  </span>
</div>

<div
  class="annotation-points__bottom"
  [ngClass]="{'isDialog': isDialog}"
>
  @for (des of curAnn.getAnnotations(); track $index) {
    <div
      class="annotation-points__text-container"
      (click)="curAnn.selectAnnotation(des)"
      (keydown)="null"
      [ngClass]="{'selectedAnnPoint bold':(des.$$selected === undefined && curAnn.selectedAnnotation &&
                                           curAnn.selectedAnnotation.description.description === des.description.description) ||
                                           des.$$selected}"
    >
      <span class="annotation-points__text">
        {{$index + 1}}. {{des.description.description}}
      </span>
    </div>
  }
</div>
